import store from '@/store';
import router from '@/router';
import localize from '@/filters/localize';
import api from '@/api/api';
import {ROLES} from '@/enums/roles';

let fraktusUrl = process.env.VUE_APP_FRAKTUS_URL;

export default {
  backToLogin() {
    window.location.pathname = '/login';
  },
  goToFraktus() {
    window.location.href = fraktusUrl;
  },
  clearUserData() {
    store.commit('changeUserData', null);
    localStorage.removeItem('userData');
  },
  saveUserData(userData) {
    store.commit('changeUserData', userData);
    localStorage.setItem('userData', JSON.stringify(userData));
  },
  afterLogin(locale) {
    api.updateUserSettings({locale: locale});
    const redirect = router.currentRoute.query.redirect;
    if (typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//')) {
      return router.push(redirect);
    }
    router.push({name: 'home'});
  },
  logOut() {
    let isCustomer = store.getters.isCustomer;
    this.clearUserData();
    isCustomer ? this.goToFraktus() : router.push({name: 'login'});
  },
  saveRequestId(id) {
    localStorage.setItem('open_request', id);
  },
  getErrors(response) {
    if (response.status === 500) {
      return '!!! SERVER ERROR !!!';
    } else {
      if (!response.data || (response.data && !response.data.errors && !response.data.message)) return '!! SOMETHING WENT WRONG !!';
      if (response.data.errors) {
        let errors = Object.keys(response.data.errors).map(key => [key, response.data.errors[key]]);
        return errors[0][1].join(' ');
      }
      if (response.data.message) {
        return response.data.message;
      }
    }
  },
  totalWeight(goods) {
    let totalWeight = goods.reduce(
      (acc, item) => acc + Number(item.weight),
      0,
    );
    return isNaN(totalWeight) ? 0 : totalWeight;
  },
  totalVolume(goods) {
    let totalVolume = parseFloat(goods.reduce((acc, item) => acc + Number(item.volume), 0).toFixed(4));
    return isNaN(totalVolume) ? 0 : totalVolume;
  },
  showGlobalSnackbar(color, text) {
    store.commit('changeGlobalSnackbarColor', color);
    store.commit('changeGlobalSnackbarText', text);
    store.commit('changeGlobalSnackbar', true);
  },
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  },
  timeIntervals() {
    let arr = [], i, j;
    for (i = 0; i < 24; i++) {
      for (j = 0; j < 2; j++) {
        arr.push(('0' + i).slice(-2) + ':' + (j === 0 ? '00' : '30'));
      }
    }
    return arr;
  },
  intervals() {
    let localIntervals = [...this.timeIntervals().map(item => {
      return {key: item, value: item};
    })];
    localIntervals.unshift({key: '', value: localize('anyTime')});
    return localIntervals;
  },
  todayDate() {
    const today = new Date();
    return this.formatDate(today);
  },
  yearAgoDate() {
    const today = new Date();
    const oneYearAgo = new Date(today);
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    return this.formatDate(oneYearAgo);
  },
  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  },
  // System-type notifications (Smart Quote pipeline) aren't tied to a request and have no
  // details view to deep-link to (e.g. related_id "SQ-118") — only numeric request ids
  // are linkable. Shared by the dropdown and the list page so both agree on the rule.
  isNotificationLinkable(item) {
    return /^\d+$/.test(String(item.related_id));
  },
  // Every role's request/quote/booking detail lives on its own *-request-details route,
  // always keyed by the request id — true for every CX-21 notification type, since
  // `related_id` is the request id even for a Quote/Booking notification (the offer
  // itself is shown inside that same request-details page).
  notificationDetailsRoute(role, relatedId) {
    let name = 'request-details';
    if (role === ROLES.COMPANY) name = 'company-request-details';
    if (role === ROLES.ADMIN) name = 'admin-request-details';
    return {name, query: {request_id: relatedId}};
  },
  async copyToClipboard(text) {
    if (!text) throw new Error('empty');
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const success = document.execCommand('copy');
      document.body.removeChild(textarea);
      if (!success) throw new Error('execCommand failed');
    }
  },
};
